module.exports = __webpack_public_path__ + "static/img/Lance_Franklin_mobile.594f4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lance_Franklin_mobile.jpg
// module id = 911k
// module chunks = 0